import { useEffect } from "react";
import CheckIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

import NitroPopup from "./Popup";
import { useNitroStore } from "../store/Store";

const EditingSnacks = () => {
  const [
    savedNotificationOpen,
    failedNotificationOpen,
    closeNotifications,
    message,
    errorMessage,
  ] = useNitroStore((state) => [
    state.savedNotificationOpen,
    state.failedNotificationOpen,
    state.closeNotifications,
    state.message,
    state.errorMessage,
  ]);

  return (
    <>
      <NitroPopup
        open={savedNotificationOpen}
        close={() => {
          closeNotifications();
        }}
        color="success"
      >
        <CheckIcon />
        <div>{message}</div>
      </NitroPopup>
      <NitroPopup
        tooltip={`Error: ${errorMessage}`}
        open={failedNotificationOpen}
        close={() => {
          closeNotifications();
        }}
        color="error"
      >
        <CloseIcon />
        <div>{message}</div>
      </NitroPopup>
    </>
  );
};

export default EditingSnacks;
